module.exports = __webpack_public_path__ + "static/media/konsep_2.9f252e74.jpg";